import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtendedSearchTypesService } from './extended-search-types.service';
import { ExtendedSearchListComponent } from './extended-search-list/extended-search-list.component';
import { ExtendedSearchListService } from './extended-search-list.service';

@NgModule({
    imports: [CommonModule],
    declarations: [ExtendedSearchListComponent],
    providers: [ExtendedSearchTypesService, ExtendedSearchListService],
})
export class ExtendedSearchModule {}
